var path = 'src/app/components/common/form-section/form-section.template.html';
var html = "<div class=\"form-section\">\n\t<h2 class=\"section-header\" ng-if=\"$ctrl.formTitle\">{{$ctrl.formTitle}}</h2>\n\t<div ng-transclude></div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;